import { useEffect, useState } from "react";

interface Props {
  phien: any;
}
const RenderAutoDat = ({ phien }: Props) => {
  const [data, setData] = useState<
    { name: string; theLoai: string; gioiHan: number }[]
  >([]);
  const [giay, setGiay] = useState(phien?.second);

  useEffect(() => {
    setGiay(phien?.second);
    const theLoai = [
      "LONG",
      "SHORT",
      "SINGLE",
      "DOUBLE",
      "LS",
      "SS",
      "LD",
      "SD",
    ];

    const randomName = () => `****${Math.floor(1000 + Math.random() * 9000)}`;
    const randomTheLoai = () =>
      theLoai[Math.floor(Math.random() * theLoai.length)];
    const randomGioiHan = () => Math.floor(Math.random() * 400) + 100;

    const addRandomData = () => {
      setGiay((prevGiay: any) => {
        setData((prevData) => [
          {
            name: randomName(),
            theLoai: randomTheLoai(),
            gioiHan: randomGioiHan(),
          },
          ...prevData,
        ]);
        return prevGiay - 3; // Reduce giay by 3

        // if ((prevGiay > 10 && prevGiay < 50) || (prevGiay > 70 && prevGiay < 100)) {
        //   setData((prevData) => [
        //     { name: randomName(), theLoai: randomTheLoai(), gioiHan: randomGioiHan() },
        //     ...prevData,
        //   ]);
        //   return prevGiay - 3; // Reduce giay by 3
        // }
        // return prevGiay; // No change if giay <= 40
      });
    };
    // Clear data and start fresh
    setData([]);
    // Add initial random data
    addRandomData();

    // Add random data every 3 seconds
    const interval = setInterval(() => {
      addRandomData();
    }, 3000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [phien]);

  return (
    <div className="box-auto-cuoc" >
      <div className="d-flex p-3 py-2 heading">
        <div className="w-100 text-center">Người dùng</div>
        <div className="w-100 text-center">Số lượt</div>
        <div className="w-100 text-center">Thể loại</div>
        <div className="w-100 text-center">Giới hạn</div>
      </div>

      <div className="children" style={{ overflowY: "auto", color: "rgb(246, 206, 30)" }}>
        {data.map((item, index) => {
          return (
            <div
              className="d-flex p-2 align-items-center"
              style={{ borderBottom: "1px solid rgb(98 98 98)" }}
              key={index}
            >
              <div className="w-100 text-center">{item.name}</div>
              <div className="w-100 text-center">{phien?.id}</div>
              <div className="w-100 text-center">{item?.theLoai}</div>
              <div className="w-100 text-center">{item?.gioiHan}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RenderAutoDat;
